module.exports = __webpack_public_path__ + "img/down.fea44271.svg";